import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyJsdReportsRoute: InvariantJiraRoute = {
	name: 'legacy-jsd-reports',
	path: '/projects/:projectKey/reports/:reportType',
};
